/*
 * @see [Documentation](https://nuxt-graphql-middleware.dulnan.net/advanced/templates#operation-hashes)
 */
export const operationHashes = {
  "acceptDisputeProposal": "wYp1JKeBC4",
  "activeChannel": "0tVV3Csc2o",
  "activeCustomer": "fTXy7TQuTA",
  "activeCustomerAddresses": "Wj6gfd81lZ",
  "activeCustomerOrders": "KMXP-thFFz",
  "activeOrder": "XtFeUpT8JW",
  "addDisputeProposal": "k9UZgRMfFy",
  "addItemToOrder": "Lmcsr-0uhp",
  "addPaymentToOrder": "_KM35VPDaT",
  "adjustOrderLine": "lJJt11-qAq",
  "applyCouponCode": "QVX9Kg134f",
  "authenticate": "ne9zGh42wS",
  "availableCountries": "8LISOIFinx",
  "collection": "37ToxMRHOj",
  "collections": "rcVO0SUKMF",
  "createAssets": "sMrKEuqbxf",
  "createComgatePayment": "IvZtK6cABS",
  "createCustomerAddress": "KguIgXVkEt",
  "createDispute": "X1SP32y9hj",
  "createProductReview": "h-jjo4Ng5D",
  "createStripePaymentIntent": "u9BrbQo9T4",
  "deleteCustomerAddress": "HFEY12k_VT",
  "detectIntent": "kweb7JKDXz",
  "dispute": "Exh1a_rARJ",
  "disputes": "E5srfLzwIP",
  "eligibleDisputeReasons": "bLX2iTgbuo",
  "eligiblePaymentMethods": "4E8cTQNClJ",
  "eligibleShippingMethods": "Vus3T3JanV",
  "facet": "RGdaQULqfN",
  "facetValue": "N3hmQ7c9Qr",
  "facets": "UlaOQ0s_Jz",
  "getOrderByCodeAndEmail": "t5ZSh4RN5A",
  "isEligibleToCreateDispute": "gOyxLVb6wm",
  "login": "p0_pR17n7s",
  "logout": "NP8hhM1X_E",
  "me": "mTEmVl2Kk_",
  "nextOrderStates": "npShkmQ3CH",
  "oracle": "Lpcf3IN7U0",
  "order": "d7e94_vVCq",
  "orderByCode": "iVep9zMjQ8",
  "page": "iUf8fbBE2F",
  "pages": "-j8HuT_FUq",
  "product": "IPug0np6QS",
  "productReviews": "8r28LjNDU4",
  "productSizeChartTables": "_g9_G6I8b2",
  "products": "eSqVbcKpkg",
  "refreshCustomerVerification": "JxB8x0aepb",
  "registerCustomerAccount": "PVZkkyYgAB",
  "rejectDisputeProposal": "Dzwavna0Vo",
  "removeAllOrderLines": "61cE579bQS",
  "removeCouponCode": "7I7Frc3iSN",
  "removeOrderLine": "XsBngLArvD",
  "requestPasswordReset": "pk3Kb3mlaq",
  "requestUpdateCustomerEmailAddress": "DKTvmAL7NX",
  "resetPassword": "bPdxN-QCMX",
  "reviews": "avGAYSPndQ",
  "search": "hUKuixF2Gx",
  "searchFacetValues": "-8qeBMnBRw",
  "searchPrices": "u3dKO3ehgU",
  "searchProduct": "AY2xQ4XokA",
  "searchStore": "h2gOPQbrqN",
  "setCustomerForOrder": "-FgZ9B5wki",
  "setIntermediatePaymentMethod": "PiR1Ltm0hc",
  "setOrderBillingAddress": "5WIgJa_t_S",
  "setOrderCustomFields": "eOWfwEXiPF",
  "setOrderShippingAddress": "QDZy9fLSeW",
  "setOrderShippingMethod": "y3J8RzgosU",
  "subPage": "mv__N9ndi3",
  "subPages": "-n-mceYOxF",
  "transitionOrderToState": "_QeFxnJn2V",
  "updateCustomer": "FGisBvq4ET",
  "updateCustomerAddress": "J672GGPbup",
  "updateCustomerEmailAddress": "LpBwLzldBP",
  "updateCustomerPassword": "dv4lsmQV6V",
  "updateDisputeProposal": "O4boSmdqo5",
  "verifyCustomerAccount": "7XNI0fqpKS",
  "voteOnReview": "amYLs2UcP1"
}